import { NAV_TYPES } from '../../LoggerFactory/BiAnalyticsLogger/events/consts';
import {
  getCompressedContentKey,
  getCompressedMdContent,
} from '../../../utils/changelogPimple/utils';
import { removeStartingSlash } from '../../../utils/locationUtils';
import { isClientSide } from '../../../common/utils';

export const isSubTreeKey = (key) => key[0] === '/';

export const getFirstItemHrefInSection = (type, i) => {
  const firstMenuItem = document.querySelectorAll(
    `[data-section="${type}-menu-section-${i}"] a`,
  )[1];
  return (
    firstMenuItem &&
    firstMenuItem.attributes.href.value &&
    firstMenuItem.attributes.href.value.split('?')[0]
  );
};

export const generatePrefix = (separator) => (prefix, text) => {
  if (prefix) {
    if (!text) {
      return `${prefix}`;
    }
    return `${prefix}${separator}${text}`;
  }
  return text;
};

export const keyPrefix = generatePrefix('.');

export const sectionPrefix = generatePrefix('/');

export const mdHeadingPrefix = generatePrefix('_');

export const getIsNavigatedWithMenuLinks = (location) => {
  const navType = location && location.state && location.state.navType;
  return (
    navType === NAV_TYPES.MENU_CATEGORY || navType === NAV_TYPES.MENU_ARTICLE
  );
};

const getCompressedContentFromLocalStorage = (store, link) => {
  const entryId = removeStartingSlash(link);
  const localStorageKey = getCompressedContentKey(store, entryId);
  if (isClientSide()) {
    try {
      const localStorageValue = window.localStorage.getItem(localStorageKey);
      return localStorageValue && JSON.parse(localStorageValue);
    } catch (e) {
      console.error(e);
      window && window.Sentry.captureException(e);
    }
  }
  return undefined;
};

export const getShouldShowPimple = (
  store,
  isChangelog,
  content,
  link,
  isLinkActive,
) => {
  if (!isChangelog || !isClientSide()) {
    return false;
  }
  const compressedContentFromLocalStorage =
    getCompressedContentFromLocalStorage(store, link);
  const compressedContent = getCompressedMdContent(content);
  return (
    !isLinkActive && compressedContent !== compressedContentFromLocalStorage
  );
};
